import { useState } from "react";
import TextInput from "../../TextInput/TextInput.jsx";
import * as styled from "./FirstStep.styled.jsx";
import SelectTeacher from "../../../components/SelectTeacher/SelectTeacher"; 

function FirstStep({ firstStepFields, register, setFormValue, errors, setTeacherId, setManagerId, teacherTrialLesson, setTeacherTrialLesson, isTrial }) {
  const [teacherClick, setTeacherClick] = useState(false);
  const [managerClick, setManagerClick] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [manager, setManager] = useState([]);
  const [loading, setLoading] = useState(false); 
  const [teacherTrialClick, setTeacherTrialClick] = useState(false);
  const [selectedTrialTeacher, setSelectedTrialTeacher] = useState("");


  const handleClick = (value, name) => {
    setTeacherId(value)
    setFormValue("teacherName", name);
    setSelectedTeacher(name);
    setTeacherClick(false);
  };
  const handleManagerClick = (value, name) => {
    setManagerId(value)
    setSelectedManager(name);
    setManagerClick(false);
  };

  const handleTeacherTrialClick = (id, name) => {
    setTeacherTrialLesson(id)
    setSelectedTrialTeacher(name)
    setTeacherTrialClick(false)
  }

  return (
    <styled.Wrapper>
      {firstStepFields.map(({ name, inputName }) => (
        <TextInput
          key={name}
          fieldName={inputName}
          name={name}
          register={register}
          errors={errors}
        />
      ))}
      <SelectTeacher setLoading={setLoading} loading={loading} setTeachers={setTeachers} teachers={teachers} setTeacherClick={setTeacherClick} teacherClick={teacherClick} handleClick={handleClick}  selectedTeacher={selectedTeacher}/>
      {!isTrial && <SelectTeacher setLoading={setLoading} loading={loading} setTeachers={setTeachers} teachers={teachers} setTeacherClick={setTeacherTrialClick} teacherClick={teacherTrialClick} handleClick={handleTeacherTrialClick}  selectedTeacher={selectedTrialTeacher} title={"Вчитель - пробний урок"}/>}
       {!isTrial && <SelectTeacher isManager setLoading={setLoading} loading={loading} setTeachers={setManager} teachers={manager} setTeacherClick={setManagerClick} teacherClick={managerClick} handleClick={handleManagerClick}  selectedTeacher={selectedManager} title={"Менеджер"}/>}
    </styled.Wrapper>
  );
}

export default FirstStep;
